/**
 * Simple in-memory cache for API responses
 * Reduces redundant API calls and improves performance
 */

const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes
const cache = new Map();

/**
 * Get cached data if it exists and hasn't expired
 * @param {string} key - Cache key
 * @returns {any|null} Cached data or null if not found/expired
 */
export const getCachedData = (key) => {
  const cached = cache.get(key);
  
  if (!cached) {
    return null;
  }
  
  const isExpired = Date.now() - cached.timestamp > CACHE_DURATION;
  
  if (isExpired) {
    cache.delete(key);
    return null;
  }
  
  return cached.data;
};

/**
 * Store data in cache with timestamp
 * @param {string} key - Cache key
 * @param {any} data - Data to cache
 */
export const setCachedData = (key, data) => {
  cache.set(key, {
    data,
    timestamp: Date.now()
  });
};

/**
 * Clear all cached data
 */
export const clearCache = () => {
  cache.clear();
};

/**
 * Clear specific cache entry
 * @param {string} key - Cache key to clear
 */
export const clearCacheKey = (key) => {
  cache.delete(key);
};

/**
 * Get cache statistics
 * @returns {object} Cache stats
 */
export const getCacheStats = () => {
  return {
    size: cache.size,
    keys: Array.from(cache.keys())
  };
};
